import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { formatCurrency } from '@eig-builder/core-utils/helpers/currency-helper'
import isEmpty from 'lodash/isEmpty'
import first from 'lodash/first'
import isNil from 'lodash/isNil'
import FulfillmentTypes from '../../../../core/enums/fulfillment-types'

import { isHexColor } from '@eig-builder/core-utils/helpers/color-helper'
import { withStyles } from '@eig-builder/core-ui/styles'
import Radio from '@eig-builder/core-ui/Radio'
import RadioGroup from '@eig-builder/core-ui/RadioGroup'
import Typography from '@eig-builder/core-ui/Typography'
import Text from 'localize'
import './lang'

import productTypes from '../../../../core/enums/product-type'

const styles = theme => ({
  pickupLabel: {
    fontWeight: '600',
    lineHeight: '24px'
  },
  radioGroupStyle: {
    display: 'contents'
  },
  buttonStyle: {
    cursor: 'pointer',
    marginRight: '10px'
  }
})

class CartItemComponent extends Component {
  static propTypes = {
    productId: PropTypes.string.isRequired,
    variantId: PropTypes.number,
    productInfo: PropTypes.shape({
      name: PropTypes.string,
      price: PropTypes.number,
      images: PropTypes.array,
      selected_options: PropTypes.array,
      stock: PropTypes.number,
      showMaxStockWarning: PropTypes.bool,
      product_type: PropTypes.number,
      fulfillment_type: PropTypes.number
    }),
    currency: PropTypes.object.isRequired,
    removeProductFromCart: PropTypes.func.isRequired,
    clearProductFromCart: PropTypes.func.isRequired,
    updateProductQuantity: PropTypes.func.isRequired,
    addProductToCart: PropTypes.func.isRequired,
    updateFulfillmentMethod: PropTypes.func.isRequired,
    fulfillmentMethodSelected: PropTypes.number,
    classes: PropTypes.object.isRequired
  }

  state = {
    quantity: 1
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const { productId, variantId, quantity, updateProductQuantity, productInfo: { product_type: productType } } = nextProps

    let newQuantity = quantity

    if (productType === productTypes.DIGITAL && quantity !== 1) {
      newQuantity = 1
      updateProductQuantity(productId, variantId, 1)
    }

    return {
      quantity: newQuantity
    }
  }

  decreaseQuantity = (productId, variantId) => event => {
    this.props.removeProductFromCart(productId, variantId)
  }

  updateQuantity = (productId, variantId) => event => {
    event.persist()

    const amount = parseInt(event.target.value)
    // Only update when there is a numeric value and it is not 0
    if (amount) {
      this.props.updateProductQuantity(productId, variantId, amount)
    }
  }

  increaseQuantity = (productId, variantId) => event => {
    this.props.addProductToCart(productId, variantId)
  }

  setFulfillmentMethod = (productId, variantId, obj) => {
    if (obj.disabled) {
      return
    }
    this.props.updateFulfillmentMethod(productId, variantId, obj.onClickType)
  }

  getRadioButtons () {
    let radioButtons = []
    if (this.props.productInfo.fulfillment_type === FulfillmentTypes.BOTH) {
      radioButtons = [
        {
          title: 'shipping',
          translationString: 'modules.cart.components.cartItem.shipping',
          onClickType: FulfillmentTypes.SHIPPABLE,
          checked: isNil(this.props.fulfillmentMethodSelected) ? (this.props.productInfo.fulfillment_type === FulfillmentTypes.BOTH) : this.props.fulfillmentMethodSelected === FulfillmentTypes.SHIPPABLE,
          disabled: false,
          value: FulfillmentTypes.SHIPPABLE
        },
        {
          title: 'pickup',
          translationString: 'modules.cart.components.cartItem.pickup',
          onClickType: FulfillmentTypes.PICKUP,
          checked: this.props.fulfillmentMethodSelected === FulfillmentTypes.PICKUP,
          disabled: false,
          value: FulfillmentTypes.PICKUP
        }
      ]
    } else if (this.props.productInfo.fulfillment_type === FulfillmentTypes.PICKUP) {
      radioButtons = [
        {
          translationString: 'modules.cart.components.cartItem.pickupOnly'
        }
      ]
    }
    return radioButtons
  }

  render () {
    const {
      productId,
      variantId,
      currency,
      productInfo: {
        name,
        price,
        images,
        stock,
        fulfillment_type: fulfillmentType,
        selected_options: selectedOptions,
        showMaxStockWarning,
        product_type: productType
      }
    } = this.props

    const { quantity } = this.state
    const classes = this.props.classes
    const radioOptions = this.getRadioButtons()

    if (isNil(name) && isNil(price)) {
      return null
    }

    const image = !isEmpty(images) && first(images).source
    const isNotDigital = productType !== productTypes.DIGITAL

    return (
      <div className='row cart-product'>
        <div className='col-12'>
          <div className='row'>
            <div className='col-3 px-0 img-container'>
              <div style={{ backgroundImage: `url(${image})` }} className='product-img img-ratio-fill' />
            </div>
            <div className='col-9 pr-0'>
              <div className='row'>
                <div className='col-12'>
                  <div className='summary-title text-truncate'>{name}</div>
                  {
                    selectedOptions && selectedOptions.map((option, index) => {
                    let color
                    const isColor = isHexColor(option.item2)

                    if (isColor) {
                      color = <span key={'color-span-' + index} className='variant-color' style={{ backgroundColor: option.item2 }} />
                    }

                    const className = classNames('variant-option', { 'f-width': !isColor })
                    return (
                      <Fragment key={'variant-div-' + index}>
                        <div className={className}>
                          {option.item1}: {!isColor ? option.item2 : ''}
                        </div>
                        {isColor ? color : ''}
                      </Fragment>
                    )
                  })
}
                </div>
              </div>
            </div>

            <div className='product-col col-5 col-sm-3 ml-auto cart-product-select'>
              <div className='card-quantity'>
                {
                  isNotDigital &&
                    <div className='number-input-wrapper'>
                      <div
                        className='min-quantity primary primary-border'
                        onClick={this.decreaseQuantity(productId, variantId)}
                      > -
                      </div>

                      <input
                        type='text'
                        value={quantity}
                        className='input-quantity primary primary-border nofocusoutline'
                        onChange={this.updateQuantity(productId, variantId)}
                      />

                      <div
                        className='plus-quantity primary primary-border'
                        onClick={this.increaseQuantity(productId, variantId)}
                      > +
                      </div>
                    </div>
                }
              </div>
            </div>

            <div className='product-col col-4 col-sm-1 cart-price es-subtitle-sm primary'>
              {
                formatCurrency((price * quantity).toFixed(2), currency)
              }
            </div>
            {isNotDigital && showMaxStockWarning &&
              <div className='cart-product-col col-9 col-sm-1 ml-auto cart-stock-warn'>
                <Text message='modules.cart.components.cartItem.stockWarning' values={[stock]} />
              </div>}
            <div className='cart-product-col col-9 col-sm-1 ml-auto cart-delete-item'>
              <span
                className='span-link'
                onClick={() => this.props.clearProductFromCart(productId, variantId)}
              >
                <Text message='modules.cart.components.cartItem.remove' />
              </span>
            </div>
          </div>
        </div>
        {fulfillmentType === FulfillmentTypes.BOTH
          ? <div>
            <div>
              <Typography variant='h4'>
                <Text message='modules.cart.components.cartItem.choose' />
              </Typography>
            </div>
            <div className='row'>
              <RadioGroup className={classes.radioGroupStyle} defaultValue={FulfillmentTypes.SHIPPABLE}>
                {radioOptions.map(button => {
              return <>
                <div className={classes.buttonStyle} onClick={() => this.setFulfillmentMethod(productId, variantId, button)}>
                  <Radio
                    checked={button.checked}
                    title={button.title}
                    disabled={button.disabled}
                    value={button.value}
                  />
                  <Text className='pt-2 mt-1' message={button.translationString} />
                </div>
              </>
            })}
              </RadioGroup>
            </div>
          </div>
          : ((fulfillmentType === FulfillmentTypes.SHIPPABLE || fulfillmentType === FulfillmentTypes.PICKUP) && !!radioOptions.length)
          ? <div>
            <Typography variant='h4' className='mt-3'>
              <Text message={radioOptions[0].translationString} />
            </Typography>
          </div>
          : <> </>}
      </div>
    )
  }
}

export default withStyles(styles)(CartItemComponent)
